import React, { useEffect, useState } from 'react';
import { Prompt } from 'react-router';
//
import { useSelector, useDispatch } from 'react-redux';
// //
// import { hideLoading } from 'react-redux-loading-bar';
//
import { publish } from 'app/libs/core/PubSub';
import * as way from 'app/libs/core/PubSubWays';
//
import withTranslations from 'app/components/HOGs/withTranslations';
import { useActions } from 'app/components/Utility/hooks/useAction.hooks';
import { pageScope } from 'app/constants/mapConstants';
// ACTION TYPES
import { API } from 'app/API/manager';

// REDUX
import store, { history } from 'app/store';

// ACTION
import { mainMenuCollapse } from 'actions/Menu/main_menu.action';
import {
  changeTourMode,
  setTourFullData,
} from 'actions/Map/tour.full.data.action';

import withMobileDetecting from 'app/components/HOGs/detectMobileDesign';

import {
  prepateTourData,
  setTourOwner,
  setTourAmount,
  markJustImportedTour,
  setIsClearTour,
} from 'app/actions/FullTour/full_tour_view.action';

import { setTypeMouseCursor } from 'app/actions/Core/css.effect.action';

import { placeAPI } from 'app/API/place.service.api';

// COMPONENT
import TourFullPreview from './tourFull';
import Preview from './Points/PreviewPoints';
import Previewer from '../TourPreview/preview.conteiner';
// COMPONENT MOBILE
import TourFullViewMobile from '../../Mobile/FullTourView/fullTourViewMobile';

// UTILITY
import { getQueryStringParams } from '../../Utility/utility';
import { deleteTourDay } from '../../Utility/deleteTour';
import checkPrevLink from '../../Utility/checkPrevUrlLink';
// CSS
import './tourFull.css';

// SVG
// import { BookmarkIcon, BookmarkShapeIcon } from '../MainMenu/svg';

import { trackModel } from './Models/track.model';
import {
  emptyTourModel,
  cpTourModel,
  cpTourPartModel,
} from './Models/tour.model';

import { trackAPI } from '../../../API/track.api';

import { userRole } from '../../../constants/user.constants';

import PageLoader from '../Default/pageLoader';

import {
  userInfoForTour,
  getTourId,
  updateIndex,
  isWrongRoutesExists,
  isThereAnyWrongRouteInAllTourPages,
  isShapingDataExists,
} from './extraFuncs';

let currentTourId = 0;

const TourFull = (props) => {
  const { isMobileDesign, tr } = props;
  const dispatch = useDispatch();

  const { scope } = useActions();

  const wasJustImported = useSelector(
    (store) => store.tourFullData.wasJustImported
  );
  const isEditMode = useSelector((store) => store.tourFullData.isEditMode);
  const fetching = useSelector((store) => store.tourFullData.fetching);
  const error = useSelector((store) => store.tourFullData.error);

  const owner = useSelector((store) => store.tourFullData.data.user);
  const id = useSelector((store) => store.tourFullData.data.id);
  const gps = useSelector((store) => store.tourFullData.gps);

  const isClearTour = useSelector((store) => store.tourFullData.isClearTour);
  const prevPoly = useSelector((store) => store.fetchPreviewPoly);
  const location = useSelector((store) => store.router.location);

  const isLoggedIn = useSelector((store) => store.authentication.isLoggedIn);
  const user = useSelector((store) => store.authentication.user);

  const mouseCursorIconType = useSelector(
    (store) => store.cssEffect.mouseCursorIconType
  );

  const { previousLocation, currentLocation } = useSelector(
    (store) => store.locationUrl
  );

  const [isPageBlocked, setIsPageBlocked] = useState(false);

  const setPageBlock = (val) => setIsPageBlocked(val);

  const setCurrentTourId = (id) => {
    currentTourId = id;
  };

  const clearTour = () => {
    const { twister_data } = store.getState().tourFullData.data;

    dispatch(setIsClearTour(true));
    dispatch(
      setTourFullData({
        ...emptyTourModel(userInfoForTour(user)),
        id,
        twister_data,
      })
    );
    dispatch(setTourAmount(true));
  };

  const prepareTrackData = (copy, user) => {
    const { id = '', name = '', sex = '', avatar = '' } = user;
    trackAPI.getFullDataTrack(copy).then((res) => {
      const data = { ...trackModel(res.response, { id, name, sex, avatar }) };
      if (copy) {
        dispatch(changeTourMode(true));
      }
      setTimeout(() => {
        dispatch(setTourFullData(data));
      }, 1000);
      scope(pageScope.drive);
    });
  };

  const prepareTourCopyData = (copy, user, part, share_key) => {
    API.way.tour
      .getOne('id', { id: copy, share_key, scope: 'web' })
      .then((resp) => {
        // const { multiDay } = resp.data.response;
        const tour =
          part > 0
            ? { ...cpTourPartModel(resp.data.response.parts[part - 1], user) }
            : { ...cpTourModel(resp, user) };

        dispatch(setTourFullData(tour));
        scope(pageScope.drive);
        if (copy) {
          dispatch(changeTourMode(true));
        }
        // if (multiDay === true) {
        //   publish(way.SAVE_MULTI_DAY_COPY_TO_CREATE, { tour, user });
        // }
        dispatch(setTourAmount());
      });
  };

  const preparePlaceData = (place) => {
    placeAPI.getPlaceFullDataById(place).then((res) => {
      const { lat, lng } = res.response;
      publish(way.DRIVE_MAP_CLICK, { lat, lng, draggable: true, type: 'via' });
    });
  };

  useEffect(() => {
    dispatch(mainMenuCollapse(true));
    setCurrentTourId(getTourId({ location }));
    let copy = 0;
    let track = 0;
    let place = 0;
    let part = 0;
    let shareKey;
    if (location) {
      const { search } = location;
      shareKey = getQueryStringParams(search).share_key;
      const params = search.split('&');
      if (params[0].split('=').shift() === '?copy') {
        copy = params[0]?.split('=').pop();
        if (params[1]?.split('=').shift() === 'part') {
          part = +params[1]?.split('=').pop();
        } else {
          track = params[1]?.split('=').pop();
        }
      } else {
        place = params[0].split('=').pop();
      }
    }
    if (currentTourId) {
      dispatch(prepateTourData(currentTourId, shareKey));
      scope(pageScope.drive);
      if (wasJustImported) {
        dispatch(setTourAmount());
        dispatch(changeTourMode(true));
      }
    } else if (copy) {
      if (track) {
        prepareTrackData(copy, user);
      } else {
        prepareTourCopyData(copy, user, part, shareKey);
      }
    } else {
      dispatch(setTourFullData({ ...emptyTourModel(userInfoForTour(user)) }));
      dispatch(changeTourMode(true));
      dispatch(setTourAmount());
      if (place) {
        preparePlaceData(place);
      }
    }
    return () => {
      dispatch(mainMenuCollapse(false));
      currentTourId = 0;
    };
  }, []);

  useEffect(() => {
    if (!fetching && error) {
      history.push('/tour');
    }
  }, [error]);

  useEffect(() => {
    const { share_key: shareKey } = getQueryStringParams(location.search);
    const newId = getTourId({ location });
    if (newId && newId !== currentTourId) {
      currentTourId = newId;
      dispatch(prepateTourData(currentTourId, shareKey));
    }
  }, [location]);

  useEffect(() => {
    if (isEditMode) {
      updateIndex();
    }
  }, [isEditMode]);

  useEffect(() => {
    if (isLoggedIn && isEditMode && !owner?.id) {
      dispatch(setTourOwner(userInfoForTour(user)));
    }
  }, [isLoggedIn]);

  //
  // CLOSE PREVIEW
  const closePreview = () => {
    publish(way.DRIVE_MAP_STATIC_POINT_SELECTED, { customId: 0 });
  }; //
  // BOOKMARK
  // const chooseBookmark = (el, id, data) => {
  //   data.bookmark = !data.bookmark;
  //   // this.setState({ bookmark: data.bookmark });
  // };
  // const bookmark = () => {
  //   return <></>; // hide in first release
  // return (bookmarked)  ? <BookmarkShapeIcon className="bookmark" />
  //                         : <BookmarkIcon className="bookmark" />;
  // };
  //
  //     if (!currentTourId && !copy) {
  //       userAPI
  //         .getHistorySearchData(userHistory.OPTIMIZE_TOUR_SETTINGS)
  //         .then((res) => {
  //           const { code, entities } = res;
  //           if (code === 200 && entities) {
  //             if (typeof entities === 'object') {
  //               this.props.setOptimizeTourSettings(entities);
  //             }
  //           }
  //         })
  //         .catch((err) => console.log(err));
  //     }
  //   }

  const changeCursorWrapperClassName = (pointType = null) => {
    if (pointType) {
      if (pointType !== mouseCursorIconType) {
        dispatch(setTypeMouseCursor(`cursor_${pointType}`));
      }
    } else {
      dispatch(setTypeMouseCursor(''));
    }
  };

  const getUrl = (spec = '') => {
    const url = location ? location.pathname.split('/') : [];
    return url.splice(-1, 1, spec);
  };

  // const getCustomId = () => parseInt(new Date().getTime().toString().slice(-8));

  const addNewTourDay = (key, action = null) => {
    publish(way.DRIVE_BUILDER_PART_ACTION, { selectedPart: key, action });
  };

  const fullScreenMode = (state, callback) =>
    publish(way.TOOL_MAP_TOGGLE_FULL_SCREEN_MODE, { state, callback });

  const handleClose = () => {
    publish(way.DRIVE_CHANGE_CURSOR_ICON, {});
    checkPrevLink(previousLocation, currentLocation);
  };

  const getCurrentUserId = () => {
    return isLoggedIn && user ? user.id : 0;
  };

  const getCurrentUserRole = () => {
    return isLoggedIn && user ? user.role : userRole.GUEST;
  };

  const hasUserPermition = () => {
    const id = getCurrentUserId();
    return id && id === +owner?.id;
  };

  const editChoose = (mode) => {
    if (hasUserPermition()) {
      const editMode = mode || !isEditMode;
      dispatch(changeTourMode(editMode));
    }
  };

  const useAdaptive = (AdaptProps) =>
    isMobileDesign ? (
      <TourFullViewMobile {...AdaptProps} />
    ) : (
      <TourFullPreview {...AdaptProps} />
    );

  return (
    <>
      <Prompt when={isPageBlocked} message={tr['Changes may not be saved']} />
      <PageLoader gps={gps} />
      {useAdaptive({
        handleClose,
        editChoose,
        currentTourId,
        isMobileDesign,
        deleteTourDay,
        prevPoly,
        addNewTourDay,
        fullScreenMode,
        changeCursorWrapperClassName,
        currentUserId: getCurrentUserId(),
        currentUserRole: getCurrentUserRole(),
        currentUser: user,
        setPageBlock,
        closePreview,
        hasUserPermition: hasUserPermition(),
        isWrongRoutesExists,
        isThereAnyWrongRouteInAllTourPages,
        isShapingDataExists,
        markJustImportedTour,
        getUrl,
        edit: isEditMode,
        clearTour,
        isClearTour,
      })}
      <Preview
        isEditMode={isEditMode}
        closePreview={closePreview}
        editChoose={editChoose}
        hasUserPermition={hasUserPermition()}
      />
      <Previewer createTour />
    </>
  );
};

export default withTranslations(withMobileDetecting(React.memo(TourFull)));
